



import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "pageGap",
  components: {},
})
export default class pageGap extends Vue {
  async validate() {
    return true;
  }
}
